import { User } from './User';

export enum CLIENT_STATUS {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
}

export interface ClientCredentials {
    id: number;
    clientId: number;
    apiSecret?: string | undefined;
    v3email?: string | undefined;
    v3password?: string | undefined;
    readonly createdAt: Date;
    readonly updatedAt: Date;
}

export interface NewClientCredentials {
    apiSecret?: string | undefined;
    v3email?: string | undefined;
    v3password?: string | undefined;
}

export type ClientStatusType = CLIENT_STATUS.ACTIVE | CLIENT_STATUS.DELETED;
export interface Client {
    id: number;
    name: string;
    apiClientId: string;
    stuartClientId: string;
    storeId?: string | undefined;
    jetToken?: string;
    status: ClientStatusType;
    users: User[];
    readonly createdAt: Date;
    readonly updatedAt: Date;
}
export interface NewClient {
    name: string;
    apiClientId: string;
    stuartClientId: string;
    storeId?: string | undefined;
    linkedUserIds: number[];
    jetToken?: string;
}
